
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mattress-removal",
      function () {
        return require("private-next-pages/mattress-removal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mattress-removal"])
      });
    }
  